module.exports = __webpack_public_path__ + "img/regenerate-column.76a1cee3.svg";